import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FilterText } from 'components';

import { fromFilter } from 'store/selectors';
import { setFilterMiddleware } from 'store/actions';


const FilterTextContainer = props => <FilterText {...props} />;
FilterTextContainer.propTypes = {
  filter: PropTypes.string,
  middleware: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

const mapStateToProps = (state, { filter, middleware }) => ({
  value: fromFilter.getFilterMiddleware(state, filter, middleware) || '',
});

const mapDispatchToProps = (dispatch, { filter, middleware }) => ({
  onChange: ({ target: { value } }) => dispatch(setFilterMiddleware(filter, middleware, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterTextContainer);



// WEBPACK FOOTER //
// ./src/containers/FilterText.js